import LoginTemplate from "templates/auth/login";

export default function LoginPage() {
  return (
    <>
      <LoginTemplate />
    </>
  );
}
